"use strict";

var DefaultBillingAndShippingAddressHelper = {
	initialize: function () {
		var $accountAddressDefaultBillingCheckbox = $("[data-component='accountAddressDefaultBillingCheckbox']");

		$accountAddressDefaultBillingCheckbox.off("click.defaultBillingHelper");
		$accountAddressDefaultBillingCheckbox.on("click.defaultBillingHelper", (event) => {
			// 'event.currentTarget' is the accountAddressDefaultBillingCheckbox component
			var $input = $(event.currentTarget).find("[data-component='accountAddressDefaultBillingCheckbox.input']");

			// if event.target is not the input itself, we need to manually check it since it wasn't directly clicked.
			if (!$(event.target).is($input) && !$input.attr("disabled")) {
				$input.prop("checked", !$input.prop("checked"));
			}

			if (!$input.parents("[data-component='otherAddresses.populated.singleAddress.edit']").length) {
				var $otherInputs = $accountAddressDefaultBillingCheckbox.find("[data-component='accountAddressDefaultBillingCheckbox.input']").not($input);
				$otherInputs.prop("checked", false);
				$otherInputs.trigger("change");
			}

			$input.trigger("change");
		});

		var $accountAddressDefaultShippingCheckbox = $("[data-component='accountAddressDefaultShippingCheckbox']");

		$accountAddressDefaultShippingCheckbox.off("click.defaultShippingHelper");
		$accountAddressDefaultShippingCheckbox.on("click.defaultShippingHelper", (event) => {
			// 'event.currentTarget' is the accountAddressDefaultShippingCheckbox component
			var $input = $(event.currentTarget).find("[data-component='accountAddressDefaultShippingCheckbox.input']");

			// if event.target is not the input itself, we need to manually check it since it wasn't directly clicked.
			if (!$(event.target).is($input) && !$input.attr("disabled")) {
				$input.prop("checked", !$input.prop("checked"));
			}

			if (!$input.parents("[data-component='otherAddresses.populated.singleAddress.edit']").length) {
				var $otherInputs = $accountAddressDefaultShippingCheckbox.find("[data-component='accountAddressDefaultShippingCheckbox.input']").not($input);
				$otherInputs.prop("checked", false);
				$otherInputs.trigger("change");
			}

			$input.trigger("change");
		});
	},

	serializeCheckboxes: function ($form, address) {
		if (!address) {
			return;
		}

		if ($form.find("[name='address.isDefaultBilling']").length > 0) {
			var $defaultBillingCheckboxInput = $form.find("[name='address.isDefaultBilling']");
			address.isDefaultBilling = $defaultBillingCheckboxInput.prop("checked");
			address.haveAddressDefaultsChanged = address.isDefaultBilling !== ($defaultBillingCheckboxInput.attr("data-checked") === "True");
		}
		if ($form.find("[name='address.isDefaultShipping']").length > 0) {
			var $defaultShippingCheckboxInput = $form.find("[name='address.isDefaultShipping']");
			address.isDefaultShipping = $defaultShippingCheckboxInput.prop("checked");
			address.haveAddressDefaultsChanged = address.haveAddressDefaultsChanged || address.isDefaultShipping !== ($defaultShippingCheckboxInput.attr("data-checked") === "True");
		}
	}
};

module.exports = DefaultBillingAndShippingAddressHelper;
